import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';
import i18n from '../../i18n/index';
import mappers from './client-payment-service-mappers';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}accounting/client-payments/`,
  [],
  [authentication],
  [],
  false,
  120000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getFilterData() {
    return conduit.get('filters');
  },

  /**
   * @param dates
   * @param filters
   * @returns {AxiosPromise}
   */
  getTableData(dates, filters) {
    return conduit.post(
      '',
      mappers.buildClientPaymentRequestBody(dates, filters),
    );
  },

  /**
   * @param dates
   * @param filters
   * @returns {AxiosPromise}
   */
  downloadPayments(dates, filters) {
    return conduit.post(
      'download',
      mappers.buildClientPaymentRequestBody(dates, filters),
    );
  },

  /**
   * @param dates
   * @param domain
   * @returns {AxiosPromise}
   */
  downloadPaymentSpecifications(dates, domain) {
    return conduit.post(
      'specification/download',
      mappers.buildClientPaymentSpecificationsRequestBody(dates, domain),
    );
  },

  /**
   * @param selectedItems
   * @param items
   * @returns {string|*}
   */
  getNameFromFirstSelectedItem(selectedItems, items) {
    let finalString = '';
    if (selectedItems.length > 0) {
      finalString = items.find(item => item.id === selectedItems[0]).name;
      if (selectedItems.length > 1) {
        finalString += `
           + 
          ${selectedItems.length - 1} 
          ${i18n.tc('inputs.others', selectedItems.length - 1)}
        `;
      }
    } else {
      finalString += i18n.t('inputs.all');
    }
    return finalString;
  },
};



// WEBPACK FOOTER //
// ./src/services/payment-service/client-payment-service.js